import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import Aline from './Aline.png';
import Carmen from './Carmen.png';
import styles from './FunnelAssistant.module.css';
import Sulivan from './Sulivan.png';
import Tom from './Tom.png';

export type FunnelAssistantProps = {
  children: React.ReactNode;
  className?: string;
  background?: 'putty' | 'green';
  assistant?: 'Aline' | 'Carmen' | 'Sulivan' | 'Tom';
};

const assistants = {
  Aline,
  Carmen,
  Sulivan,
  Tom,
};

export const FunnelAssistant: React.FC<FunnelAssistantProps> = ({
  children,
  className,
  background = 'putty',
  assistant = 'Aline',
}) => {
  return (
    <div className={clsx(styles.assistant, className)}>
      <img className={styles.img} src={assistants[assistant]} alt='Insify support' />
      <div className={clsx(textSm, styles.assistantText, styles[background])}>{children}</div>
    </div>
  );
};
